/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { QuestionCategory } from '../questionCategory'
import { CATEGORY_DATA, LOCALES, sourceList } from '../_data'
import { groupBy } from '../_helpers'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import { Mdx } from '@ta-interaktiv/contentbricks'

const ARTICLE_ID = '24128419'
const LOCALE: 'DE' | 'FR' = 'DE'
const IS_MOBILE: boolean = browserCheck.isMobile
const QUESTIONDATA = require('../_data/fragenzukopfschmerzen - kopfschmerzfragen.csv')

export const AppComponent = () => {
  const questionData = groupBy(QUESTIONDATA, 'cat')
  const locales = LOCALES[LOCALE]
  const categories = CATEGORY_DATA

  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />
      {questionData && locales && categories && (
        <>
          <div className='ui vertical segment'>
            <div className='header_layer_2' />
            <div className='header_layer_1' />
          </div>
          <div className='ui vertical very fitted segment headline'>
            <h1>
              <div className='line1'>55</div>
              <div className='line2'>Fragen rund um</div>
              <div className='bigger'>KOPFSCHMERZEN</div>
            </h1>
          </div>
          <div
            className='ui vertical fitted segment main'
            style={{ overflow: 'hidden !important' }}
          >
            <div className='ui text container authorLead'>
              <div className='ta author'>
                Martina Frei und Sebastian Broschinski
              </div>
              <div className='ui  container introText'>
                <Mdx file={require('text/_intro.mdx')} />
              </div>
            </div>

            {categories.map((cat, i) => {
              return (
                <QuestionCategory
                  key={i}
                  isMobile={IS_MOBILE}
                  articleID={ARTICLE_ID}
                  category={cat}
                  questions={questionData[cat.id].sort((a, b) => {
                    return a.catorder - b.catorder
                  })}
                  noShare
                />
              )
            })}
          </div>
          <Footer
            articleId={ARTICLE_ID}
            questions={[
              'Wie informativ ist dieses Kompendium?',
              'Wie sehr schätzen Sie das lange Format?',
              'Wie gefällt Ihnen die Gestaltung?'
            ]}
            credits={[
              ['Text und Recherche', 'Martina Frei'],
              [
                'Konzept und Programmierung',
                'Katharina Graf, Sebastian Broschinski und Marc Brupacher'
              ],
              ['Illustrationen', 'Sebastian Broschinski'],
              ['Quellen', sourceList.join('; ')]
            ]}
          >
            <div className='ui text container'>
              <a
                className='snippet'
                href={
                  'https://interaktiv.' +
                  parseHostname().publicationName +
                  '.ch/2019/77-fragen-zum-schlaf/?nosome'
                }
              >
                <img
                  src='https://interaktiv.tagesanzeiger.ch/2019/77-fragen-zum-schlaf/fragenzumschlaf_inline_teaser.jpg'
                  width='100%'
                />
              </a>
            </div>
          </Footer>
        </>
      )}
    </div>
  )
}
